import { html } from "lit";
import { ContentTeaserTemplate } from "../../partial-templates/teaser/content/content.templates";

export const BusinessYearTemplate = () => {
    return html`
        <div
            class="ux-u-background-grey ux-u-margin-vertical-40 ux-u-margin-l-vertical-50 ux-u-margin-xl-vertical-60"
        >
            <div class="ux-row ux-u-flex-jc-center">
                <div
                    class="ux-col-12 ux-col-sm-10
                    ux-u-margin-top-60 ux-u-margin-xl-top-65 ux-u-margin-bottom-60 ux-u-margin-xl-bottom-50"
                >
                    ${ContentTeaserTemplate({
                        customImage:
                            "mock-assets/images/geschaeftjahreszahlen.png",
                        segmentation: "1-1",
                        row: true,
                    })}
                </div>
            </div>
        </div>
    `;
};
